import React, { useEffect, useMemo, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { buildPaymentQrOptions } from '../utils/paymentQr';
import { useI18n } from '../i18n/I18nContext';
import { getComponentCopy } from '../i18n/componentCopy';

const PaymentQr = ({ amountEUR, amount, currency = 'EUR', variableSymbol, note, iban, beneficiaryName }) => {
  const { language } = useI18n();
  const copy = getComponentCopy(language);
  const result = useMemo(() => buildPaymentQrOptions({
    amountEUR,
    amount,
    currency,
    variableSymbol,
    note,
    iban,
    beneficiaryName,
  }), [amountEUR, amount, currency, variableSymbol, note, iban, beneficiaryName]);
  const [selectedType, setSelectedType] = useState('');

  useEffect(() => {
    setSelectedType(result.options[0]?.type || '');
  }, [result]);

  const selectedQr = result.options.find((option) => option.type === selectedType)
    || result.options[0];

  if (!selectedQr?.value) {
    return <p className="payment-qr-error">{result.error || copy.qrUnavailable}</p>;
  }

  return (
    <div className="payment-qr">
      <strong>{copy.scan}</strong>
      {result.options.length > 1 && (
        <div className="payment-qr-formats" aria-label={copy.qrFormat}>
          {result.options.map((option) => (
            <button
              type="button"
              key={option.type}
              className={option.type === selectedQr.type ? 'active' : ''}
              onClick={() => setSelectedType(option.type)}
            >
              {option.type}
            </button>
          ))}
        </div>
      )}
      <div className="payment-qr-code">
        <QRCodeSVG value={selectedQr.value} size={264} bgColor="#ffffff" fgColor="#111111" level="Q" marginSize={2} />
      </div>
      <span className="payment-qr-caption">
        {copy.qrUsing} {selectedQr.type}. {copy.qrHelp}
      </span>
    </div>
  );
};

export default PaymentQr;
